export default {
    props: {
        value: {},
        defaultValue: {
            default: null,
        },
        rootStep: String,
    },
    data() {
        return {
            routes: {},
            values: {},
        };
    },
    methods: {
        resetRoutePath() {
            this.$router.push({
                path: this.$route.path.split('/').filter(i => !Object.values(this.routes).includes(i)).join('/'),
                query: this.$route.query,
            });
            if (this.value !== this.defaultValue) {
                this.$emit('input', this.defaultValue);
            }
        },
    },
    watch: {
        $route: {
            immediate: true,
            handler(route) {
                let found = false;

                route.path.split('/').forEach(pathPart => {
                    Object.keys(this.routes).some(k => {
                        if (pathPart === this.routes[k]) {
                            found = true;
                            this.$emit('input', this.values[k]);

                            return true;
                        }
                    });
                });

                if (!found) {
                    this.$emit('input', this.defaultValue);
                }
            },
        },
        value(value) {
            if (value === this.defaultValue) {
                this.resetRoutePath();
            }
        },
    },
};